@if (contactList) {
  <h1>
    {{ 'CONTACT.LABEL.ON_CALL' | translate }}
    <i
      class="fa fa-fw fa-address-book fa-2x"
      (click)="openContactList(contactList.id)"
    ></i>
  </h1>

  <section class="on-call-container">
    <app-contact-list-card
      [member]="contactList!.members[0]"
      [index]="0"
      (openProfileEvent)="openProfile($event)"
    />
    <app-contact-list-card
      [member]="contactList!.members[1]"
      [index]="1"
      (openProfileEvent)="openProfile($event)"
    />
  </section>
}
@if (managementContactList) {
  <br />
  <h2>
    {{ 'CONTACT.LABEL.MANAGEMENT_ON_CALL' | translate }}
    <i
      class="fa fa-fw fa-address-book fa-2x"
      (click)="openContactList(managementContactList.id)"
    ></i>
  </h2>

  <app-contact-list-card
    [member]="managementContactList!.members[0]"
    [index]="0"
    (openProfileEvent)="openProfile($event)"
  />
}
<form [formGroup]="form">
  <div formArrayName="additionalResourceLists">
    @if (additionalResourceLists().length > 0) {
      @for (
        additionalResource of additionalResourceLists();
        track additionalResource.id;
        let i = $index
      ) {
        <p-card>
          <br />
          <div class="header">
            <h2>
              {{ additionalResource.AdditionalResourceListType.name }}
              <i
                class="fa fa-fw fa-address-book fa-2x"
                (click)="openContactList(additionalResource.id)"
              ></i>
            </h2>
            @if (editMode()) {
              <span class="label right-align" id="notes-label"
                >{{ 'CONTACT.LABEL.MANAGE_CONTACT_LIST' | translate }}:</span
              >
              <div [formGroupName]="i">
                <p-select
                  [options]="
                    getContactListOptions(
                      additionalResource.AdditionalResourceListType
                    )
                  "
                  optionLabel="name"
                  optionValue="id"
                  [filter]="true"
                  filterBy="name"
                  formControlName="contactList"
                  appendTo="body"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="34"
                  class="dropdown"
                  [showClear]="true"
                  placeholder="{{
                    'CONTACT.LABEL.SELECT_CONTACT_LIST' | translate
                  }}"
                  (onChange)="
                    updateContactList(
                      $event,
                      additionalResource.AdditionalResourceListType,
                      i
                    )
                  "
                />
              </div>
            }
          </div>
          <app-progress-spinner [enabled]="loadingStates[i]" />
          @if (!loadingStates[i]) {
            <section class="resource-list-container">
              <app-contact-list-card
                [member]="additionalResource.ContactListMembers[0]"
                [index]="0"
                (openProfileEvent)="openProfile($event)"
              />
              <app-contact-list-card
                [member]="additionalResource.ContactListMembers[1]"
                [index]="1"
                (openProfileEvent)="openProfile($event)"
              />
            </section>
          }
        </p-card>
      }
    }
    @if (
      additionalResourceListTypes().length > 0 &&
      editMode() &&
      shouldRenderForm()
    ) {
      @for (
        resourceType of additionalResourceListTypes();
        track resourceType.id;
        let i = $index
      ) {
        <br />
        <p-card>
          <div class="header">
            <h2>{{ resourceType.name }}</h2>
            <span class="label right-align" id="notes-label"
              >{{ 'CONTACT.LABEL.MANAGE_CONTACT_LIST' | translate }}:</span
            >
            <div [formGroupName]="i + additionalResourceLists().length">
              <p-select
                [options]="getContactListOptions(resourceType)"
                optionLabel="name"
                optionValue="id"
                [filter]="true"
                filterBy="name"
                appendTo="body"
                [virtualScroll]="true"
                [virtualScrollItemSize]="34"
                class="dropdown"
                placeholder="{{
                  'CONTACT.LABEL.SELECT_CONTACT_LIST' | translate
                }}"
                formControlName="contactList"
                (onChange)="
                  updateContactList(
                    $event,
                    resourceType,
                    i + additionalResourceLists().length
                  )
                "
              />
            </div>
          </div>
          <app-progress-spinner
            [enabled]="loadingStates[i + additionalResourceLists().length]"
          />
        </p-card>
      }
    }
  </div>
</form>
